export default {
  common: {
    inputText: '请输入',
    selectText: '请选择',
    startTimeText: '开始时间',
    endTimeText: '结束时间',
    startDateText: '开始日期',
    endDateText: '结束日期',
    login: '登录',
    required: '该项为必填项',
    loginOut: '退出系统',
    document: '项目文档',
    profile: '个人中心',
    reminder: '温馨提示',
    loginOutMessage: '是否退出本系统？',
    back: '返回',
    ok: '确定',
    save: '保存',
    cancel: '取消',
    close: '关闭',
    reload: '重新加载',
    success: '成功',
    closeTab: '关闭标签页',
    closeTheLeftTab: '关闭左侧标签页',
    closeTheRightTab: '关闭右侧标签页',
    closeOther: '关闭其他标签页',
    closeAll: '关闭全部标签页',
    prevLabel: '上一步',
    nextLabel: '下一步',
    skipLabel: '跳过',
    doneLabel: '结束',
    menu: '菜单',
    menuDes: '以路由的结构渲染的菜单栏',
    collapse: '展开缩收',
    collapseDes: '展开和缩放菜单栏',
    tagsView: '标签页',
    tagsViewDes: '用于记录路由历史记录',
    tool: '工具',
    toolDes: '用于设置定制系统',
    query: '查询',
    reset: '重置',
    shrink: '收起',
    expand: '展开',
    confirmTitle: '系统提示',
    exportMessage: '是否确认导出数据项？',
    importMessage: '是否确认导入数据项？',
    createSuccess: '新增成功',
    updateSuccess: '修改成功',
    delMessage: '是否删除所选中数据？',
    delDataMessage: '是否删除数据？',
    delNoData: '请选择需要删除的数据',
    delSuccess: '删除成功',
    index: '序号',
    id: '编号',
    name: '名称',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    remark: '备注',
    operation: '操作',
    copy: '复制',
    copySuccess: '复制成功',
    copyError: '复制失败',
    create: '新增',
    export: '导出',
    search: '搜索',
    creator: '创建人',
    noValue: '无',
    unknown: '未知',
    warning: '警告',
    confirm: '确认',
    cancelSuccess: '取消成功',
    delete: '删除',
    deleteSuccess: '删除成功',
    edit: '编辑',
    more: '更多'
  },
  lock: {
    lockScreen: '锁定屏幕',
    lock: '锁定',
    lockPassword: '锁屏密码',
    unlock: '点击解锁',
    backToLogin: '返回登录',
    entrySystem: '进入系统',
    placeholder: '请输入锁屏密码',
    message: '锁屏密码错误'
  },
  error: {
    noPermission: `抱歉，您无权访问此页面。`,
    pageError: '抱歉，您访问的页面不存在。',
    networkError: '抱歉，服务器报告错误。',
    returnToHome: '返回首页'
  },
  permission: {
    hasPermission: `请设置操作权限标签值`,
    hasRole: `请设置角色权限标签值`
  },
  setting: {
    projectSetting: '项目配置',
    theme: '主题',
    layout: '布局',
    systemTheme: '系统主题',
    menuTheme: '菜单主题',
    interfaceDisplay: '界面显示',
    breadcrumb: '面包屑',
    breadcrumbIcon: '面包屑图标',
    collapseMenu: '折叠菜单',
    hamburgerIcon: '折叠图标',
    screenfullIcon: '全屏图标',
    sizeIcon: '尺寸图标',
    localeIcon: '多语言图标',
    messageIcon: '消息图标',
    tagsView: '标签页',
    tagsViewImmerse: '标签页沉浸',
    logo: '标志',
    greyMode: '灰色模式',
    fixedHeader: '固定头部',
    headerTheme: '头部主题',
    cutMenu: '切割菜单',
    copy: '拷贝',
    clearAndReset: '清除缓存并且重置',
    copySuccess: '拷贝成功',
    copyFailed: '拷贝失败',
    footer: '页脚',
    uniqueOpened: '菜单手风琴',
    tagsViewIcon: '标签页图标',
    reExperienced: '请重新退出登录体验',
    fixedMenu: '固定菜单'
  },
  size: {
    default: '默认',
    large: '大',
    small: '小'
  },
  login: {
    welcome: '欢迎使用本系统',
    message: '开箱即用的中后台管理系统',
    tenantname: '租户名称',
    username: '用户名',
    password: '密码',
    code: '验证码',
    login: '登录',
    relogin: '重新登录',
    otherLogin: '其他登录方式',
    register: '注册',
    checkPassword: '确认密码',
    remember: '记住我',
    hasUser: '已有账号？去登录',
    forgetPassword: '忘记密码?',
    tenantNamePlaceholder: '请输入租户名称',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    codePlaceholder: '请输入验证码',
    mobileTitle: '手机登录',
    mobileNumber: '手机号码',
    mobileNumberPlaceholder: '请输入手机号码',
    backLogin: '返回',
    getSmsCode: '获取验证码',
    btnMobile: '手机登录',
    btnQRCode: '二维码登录',
    qrcode: '扫描二维码登录',
    btnRegister: '注册',
    SmsSendMsg: '验证码已发送',
    resetPassword: '重置密码',
    resetPasswordSuccess: '重置密码成功',
    invalidTenantName: '无效的租户名称'
  },
  captcha: {
    verification: '请完成安全验证',
    slide: '向右滑动完成验证',
    point: '请依次点击',
    success: '验证成功',
    fail: '验证失败'
  },
  router: {
    login: '登录',
    socialLogin: '社交登录',
    home: '首页',
    analysis: '分析页',
    workplace: '工作台'
  },
  analysis: {
    newUser: '新增用户',
    unreadInformation: '未读消息',
    transactionAmount: '成交金额',
    totalShopping: '购物总量',
    monthlySales: '每月销售额',
    userAccessSource: '用户访问来源',
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
    estimate: '预计',
    actual: '实际',
    directAccess: '直接访问',
    mailMarketing: '邮件营销',
    allianceAdvertising: '联盟广告',
    videoAdvertising: '视频广告',
    searchEngines: '搜索引擎',
    weeklyUserActivity: '每周用户活跃量',
    activeQuantity: '活跃量',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日'
  },
  workplace: {
    welcome: '你好',
    happyDay: '祝你开心每一天!',
    toady: '今日晴',
    notice: '通知公告',
    project: '项目数',
    access: '项目访问',
    toDo: '待办',
    introduction: '一个正经的简介',
    shortcutOperation: '快捷入口',
    operation: '操作',
    index: '指数',
    personal: '个人',
    team: '团队',
    quote: '引用',
    contribution: '贡献',
    hot: '热度',
    yield: '产量',
    dynamic: '动态',
    push: '推送',
    follow: '关注'
  },
  form: {
    input: '输入框',
    inputNumber: '数字输入框',
    default: '默认',
    icon: '图标',
    mixed: '复合型',
    textarea: '多行文本',
    slot: '插槽',
    position: '位置',
    autocomplete: '自动补全',
    select: '选择器',
    selectGroup: '选项分组',
    selectV2: '虚拟列表选择器',
    cascader: '级联选择器',
    switch: '开关',
    rate: '评分',
    colorPicker: '颜色选择器',
    transfer: '穿梭框',
    render: '渲染器',
    radio: '单选框',
    button: '按钮',
    checkbox: '多选框',
    slider: '滑块',
    datePicker: '日期选择器',
    shortcuts: '快捷选项',
    today: '今天',
    yesterday: '昨天',
    aWeekAgo: '一周前',
    week: '周',
    year: '年',
    month: '月',
    dates: '日期',
    daterange: '日期范围',
    monthrange: '月份范围',
    dateTimePicker: '日期时间选择器',
    dateTimerange: '日期时间范围',
    timePicker: '时间选择器',
    timeSelect: '时间选择',
    inputPassword: '密码输入框',
    passwordStrength: '密码强度',
    operate: '操作',
    change: '更改',
    restore: '还原',
    disabled: '禁用',
    disablement: '解除禁用',
    delete: '删除',
    add: '添加',
    setValue: '设置值',
    resetValue: '重置值',
    set: '设置',
    subitem: '子项',
    formValidation: '表单验证',
    verifyReset: '验证重置',
    remark: '备注'
  },
  watermark: {
    watermark: '水印'
  },
  table: {
    table: '表格',
    index: '序号',
    title: '标题',
    author: '作者',
    createTime: '创建时间',
    action: '操作',
    pagination: '分页',
    reserveIndex: '叠加序号',
    restoreIndex: '还原序号',
    showSelections: '显示多选',
    hiddenSelections: '隐藏多选',
    showExpandedRows: '显示展开行',
    hiddenExpandedRows: '隐藏展开行',
    header: '头部'
  },
  action: {
    create: '新增',
    add: '新增',
    del: '删除',
    delete: '删除',
    edit: '编辑',
    update: '编辑',
    preview: '预览',
    more: '更多',
    sync: '同步',
    save: '保存',
    detail: '详情',
    export: '导出',
    import: '导入',
    generate: '生成',
    logout: '强制退出',
    test: '测试',
    typeCreate: '字典类型新增',
    typeUpdate: '字典类型编辑',
    dataCreate: '字典数据新增',
    dataUpdate: '字典数据编辑',
    approve: '通过',
    reject: '驳回'
  },
  dialog: {
    dialog: '弹窗',
    open: '打开',
    close: '关闭',
    confirm: '确认'
  },
  sys: {
    api: {
      operationFailed: '操作失败',
      errorTip: '错误提示',
      errorMessage: '操作失败,系统异常!',
      timeoutMessage: '登录超时,请重新登录!',
      apiTimeoutMessage: '接口请求超时,请刷新页面重试!',
      apiRequestFailed: '请求出错，请稍候重试',
      networkException: '网络异常',
      networkExceptionMsg: '网络异常，请检查您的网络连接是否正常!',
      errMsg401: '用户没有权限（令牌、用户名、密码错误）!',
      errMsg403: '用户得到授权，但是访问是被禁止的。!',
      errMsg404: '网络请求错误,未找到该资源!',
      errMsg405: '网络请求错误,请求方法未允许!',
      errMsg408: '网络请求超时!',
      errMsg500: '服务器错误,请联系管理员!',
      errMsg501: '网络未实现!',
      errMsg502: '网络错误!',
      errMsg503: '服务不可用，服务器暂时过载或维护!',
      errMsg504: '网络超时!',
      errMsg505: 'http版本不支持该请求!',
      errMsg901: '演示模式，无法进行写操作!'
    },
    app: {
      logoutTip: '温馨提醒',
      logoutMessage: '是否确认退出系统?',
      menuLoading: '菜单加载中...'
    },
    exception: {
      backLogin: '返回登录',
      backHome: '返回首页',
      subTitle403: '抱歉，您无权访问此页面。',
      subTitle404: '抱歉，您访问的页面不存在。',
      subTitle500: '抱歉，服务器报告错误。',
      noDataTitle: '当前页无数据',
      networkErrorTitle: '网络错误',
      networkErrorSubTitle: '抱歉，您的网络连接已断开，请检查您的网络！'
    },
    lock: {
      unlock: '点击解锁',
      alert: '锁屏密码错误',
      backToLogin: '返回登录',
      entry: '进入系统',
      placeholder: '请输入锁屏密码或者用户密码'
    },
    login: {
      backSignIn: '返回',
      signInFormTitle: '登录',
      ssoFormTitle: '三方授权',
      mobileSignInFormTitle: '手机登录',
      qrSignInFormTitle: '二维码登录',
      signUpFormTitle: '注册',
      forgetFormTitle: '重置密码',
      signInTitle: '开箱即用的中后台管理系统',
      signInDesc: '输入您的个人详细信息开始使用！',
      policy: '我同意xxx隐私政策',
      scanSign: `扫码后点击"确认"，即可完成登录`,
      loginButton: '登录',
      registerButton: '注册',
      rememberMe: '记住我',
      forgetPassword: '忘记密码?',
      otherSignIn: '其他登录方式',
      // notify
      loginSuccessTitle: '登录成功',
      loginSuccessDesc: '欢迎回来',
      // placeholder
      accountPlaceholder: '请输入账号',
      passwordPlaceholder: '请输入密码',
      smsPlaceholder: '请输入验证码',
      mobilePlaceholder: '请输入手机号码',
      policyPlaceholder: '勾选后才能注册',
      diffPwd: '两次输入密码不一致',
      userName: '账号',
      password: '密码',
      confirmPassword: '确认密码',
      email: '邮箱',
      smsCode: '短信验证码',
      mobile: '手机号码'
    }
  },
  profile: {
    user: {
      title: '个人信息',
      username: '用户名称',
      nickname: '用户昵称',
      mobile: '手机号码',
      email: '用户邮箱',
      dept: '所属部门',
      posts: '所属岗位',
      roles: '所属角色',
      sex: '性别',
      man: '男',
      woman: '女',
      createTime: '创建日期'
    },
    info: {
      title: '基本信息',
      basicInfo: '基本设置',
      resetPwd: '密码设置',
      userSocial: '社交绑定'
    },
    rules: {
      nickname: '请输入用户昵称',
      mail: '请输入邮箱地址',
      truemail: '请输入正确的邮箱地址',
      phone: '请输入正确的手机号码',
      truephone: '请输入正确的手机号码'
    },
    password: {
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      oldPwdMsg: '请输入旧密码',
      newPwdMsg: '请输入新密码',
      cfPwdMsg: '请输入确认密码',
      pwdRules: '长度在 6 到 20 个字符',
      diffPwd: '两次输入密码不一致'
    }
  },
  cropper: {
    selectImage: '选择图片',
    uploadSuccess: '上传成功',
    modalTitle: '头像上传',
    okText: '确认并上传',
    btn_reset: '重置',
    btn_rotate_left: '逆时针旋转',
    btn_rotate_right: '顺时针旋转',
    btn_scale_x: '水平翻转',
    btn_scale_y: '垂直翻转',
    btn_zoom_in: '放大',
    btn_zoom_out: '缩小',
    preview: '预览'
  },
  member: {
    enterprise: {
      id: '编号',
      userId: '用户编号',
      nickname: '用户昵称',
      mobile: '用户手机号',
      name: '企业名称',
      creditCode: '统一社会信用代码',
      location: '公司所在地',
      industry: '公司行业',
      scale: '公司规模',
      description: '公司简介',
      legalName: '企业法人',
      legalIdCard: '法人身份证号',
      legalIdCardFrontUrl: '法人身份证正面',
      legalIdCardBackUrl: '法人身份证背面',
      businessLicenseUrl: '营业执照',
      contactName: '联系人姓名',
      contactMobile: '联系人手机',
      status: '认证状态',
      auditRemark: '审核备注',
      auditRemarkTip: '请输入审核备注',
      auditTime: '审核时间',
      detail: '企业认证详情',
      // 创建企业相关
      create: {
        title: '创建企业',
        subtitle: '填写企业基本信息，创建后可进行企业认证，解锁更多高级功能',
        basicInfo: '企业基本信息',
        basicInfoDesc: '请填写企业的基本注册信息',
        legalInfo: '法定代表人信息',
        legalInfoDesc: '请填写法定代表人的基本信息',
        contactInfo: '联系人信息',
        contactInfoDesc: '用于接收后续认证审核结果及业务通知',
        licenseTitle: '营业执照',
        licenseOptional: '可选',
        licenseDesc: '上传营业执照可加速后续认证流程',
        tipTitle: '创建提示',
        tipContent: '创建企业后，您将成为企业所有者，可邀请成员加入并进行企业实名认证，认证后即可使用企业级电子签章等高级功能。',
        confirmTitle: '确认创建',
        confirmContent: '提交后将创建企业，您将成为该企业的所有者。',
        confirmButton: '确认创建',
        cancelButton: '再检查一下',
        submitButton: '创建企业',
        success: '企业创建成功'
      }
    }
  },
  'OAuth 2.0': 'OAuth 2.0', // 避免菜单名是 OAuth 2.0 时，一直 warn 报错

  seal:{
    // 通用
    common: {
      module: '电子签章',
      enable: '启用',
      disable: '停用', 
      revoke: '作废',
      ipWhitelist: 'IP白名单',
      edit: '编辑',
      more: '更多'
    },
    // 电子印章模块
    seal: {
      title: '印章管理',
      name: '印章名称',
      type: '印章类型',
      preview: '印章预览',
      status: '状态',
      deleteConfirm: '是否确认删除该印章？',
      authorizationManage: '授权管理',
      usageLog: '使用日志',
      enableSeal: '启用印章',
      disableSeal: '停用印章',
      revokeSeal: '作废印章',
      operationSuccess: '操作成功'
    },
    // 授权
    authorization: {
      title: '印章授权',
      user: '授权用户'
    },

    batchTask: {
      title: '批量任务',
      batchLaunch: '批量发起',
      batchSign: '批量签署'
    },

    template: {
      title: '合同模板',
      name: '模板名称',
      batchGuide: {
        title: '支持批量创建合同',
        desc: '选择模板后点击操作列「批量发起」，可基于同一模板一次性发起多份合同。',
        link: '前往批量任务'
      },
      description: '模板描述',
      
      form: {
        name: {
          label: '模板名称',
          placeholder: '请输入模板名称',
          required: '模板名称不能为空'
        },
        file: {
          label: '模板文件',
          required: '请上传模板文件'
        },
        remark: {
          label: '备注',
          placeholder: '请输入备注'
        },
        title: {
          create: '新增模板',
          update: '编辑模板'
        }
      },
      
      index: {
        name: '模板名称',
        createTime: '创建时间',
        operation: '操作'
      },
      
      preview: {
        title: '模板预览',
        empty: '暂无预览内容'
      },
      
      designer: {
        title: '在线模板设计器',
        controlTools: '控件工具箱',
        properties: '属性面板',
        fieldsManagement: '字段管理',
        controlName: '控件名称',
        required: '必填项',
        defaultValue: '默认值',
        fontSize: '字体大小',
        textAlign: '文本对齐',
        alignLeft: '左对齐',
        alignCenter: '居中对齐',
        alignRight: '右对齐',
        position: '位置',
        size: '尺寸',
        width: '宽度',
        height: '高度',
        selectOptions: '选项设置',
        addOption: '添加选项',
        importFields: '导入字段',
        exportFields: '导出字段',
        searchFields: '搜索字段',
        typeFilter: '类型筛选',
        allTypes: '全部类型',
        textType: '文本',
        numberType: '数字',
        dateType: '日期',
        selectType: '下拉选择',
        checkboxType: '复选框',
        fieldsList: '字段列表',
        fieldName: '字段',
        unnamedField: '未命名字段',
        page: '第',
        selectedFields: '已选择 {count} 个字段',
        batchSetRequired: '批量设为必填',
        batchSetOptional: '批量设为可选',
        batchDelete: '批量删除',
        quickAddField: '快速添加字段',
        pdfLoading: 'PDF加载中...',
        quickAddDialog: {
          title: '快速添加字段',
          name: '字段名称',
          type: '字段类型',
          required: '必填项',
          nameRequired: '请输入字段名称',
          typeRequired: '请选择字段类型'
        },
        messages: {
          addSuccess: '字段添加成功',
          deleteConfirm: '确定要删除该字段吗？',
          deleteSuccess: '字段删除成功',
          saveSuccess: '模板保存成功',
          saveFailed: '模板保存失败',
          saveFailedHint:
            '无法保存模板，可能是模板数据异常或与签署方信息不一致。请检查各表单字段是否已正确指定签署方后重试；若仍无法保存，请联系管理员处理。',
          noSignatoriesForFields:
            '缺少签署方信息，无法保存表单字段。请先在模板中配置签署方。',
          signatoryMissing:
            '以下控件未指定签署方：{names}。请在工具栏中为每个控件选择签署方后再保存。',
          signatoryInvalid:
            '控件「{name}」的签署方无效或已变更，请重新选择后再保存。',
          importSuccess: '字段导入成功',
          exportSuccess: '字段导出成功',
          noFieldsToExport: '没有可导出的字段',
          invalidImportData: '导入数据格式不正确'
        }
      }
    },
    signTask: {
      title: '签署任务管理',
      taskName: '任务名称',
      taskStatus: '任务状态',
      draft: '草稿',
      formFilling: '表单填写中',
      signing: '签署中',
      // 智能状态显示（区分"待我操作"和"等待他人操作"）
      waitingMeToFillForm: '待填写',
      waitingOthersToFillForm: '他人填写中',
      waitingMeToSign: '待签署',
      waitingOthersToSign: '他人签署中',
      processing: '处理中',
      completed: '已完成',
      rejected: '已拒绝',
      cancelled: '已取消',
      revoked: '已撤销',
      expired: '已过期',
      unknown: '未知状态',
      detail: '详情',
      preview: '预览',
      sign: '签署',
      template: '合同模板',
      deadline: '截止时间',
      participants: '参与人',
      participantName: '姓名',
      participantMobile: '手机号',
      signPosition: '签名位置',
      positionSet: '已设置',
      positionNotSet: '未设置',
      addParticipant: '添加参与人',
      designPosition: '设计签名位置',
      detailTitle: '签署任务详情',
      participantList: '参与人列表',
      status: '状态',
      signTime: '签署时间',
      downloadSignedFile: '下载签署文件',
      downloadTip: '点击下载已完成签署的文件',
      downloadDisabledTip: '签署任务未完成，所有参与人签署完成后才可下载',
      deleteTip: '删除此签署任务',
      deleteDisabledTip: '只有已完成、已撤销、已拒签、已过期的任务可以删除',
      cancel: '撤销任务',
      cancelTip: '撤销此签署任务',
      cancelDisabledTip: '只有表单填写中或签署中的任务可以撤销',
      cancelConfirm: '确定要撤销此签署任务吗？',
      reject: '拒签',
      rejectTip: '拒绝签署此任务',
      rejectDisabledTip: '当前状态不允许拒签',
      rejectReason: '拒签原因',
      rejectReasonPlaceholder: '请输入拒签原因',
      rejectConfirm: '确定要拒签此任务吗？',
      previewTitle: '智能文档预览',
      previewPageInfo: '当前第 {current} 页，共 {total} 页',
      pdfLoading: 'PDF文档加载中，请稍候...',
      page: '第',
      participantStatusLabel: '参与者状态',
      taskInfo: '任务信息',
      signParticipants: '签署参与者',
      progress: '进度',
      signNow: '立即签署',
      positionDesignerTitle: '签名位置设计',
      savePositions: '保存签名位置',
      createTask: '新增签署任务',
      updateTask: '修改签署任务',
      addParticipantWarning: '请添加至少一名参与人',
      participantInfoWarning: '参与人的姓名和手机号不能为空',
      createSuccess: '创建成功',
      noFileWarning: '该任务没有关联文件，无法预览',
      noFileToSignWarning: '该任务没有关联文件，无法签署',
      getDetailFailed: '获取任务详情失败',
      deleteConfirm: '确认要删除该签署任务吗?',
      noSignedFileWarning: '签署文件不存在',
      selectPositionMessage: '选择了 {name} 的签名位置',
      savePositionsSuccess: '签名位置已保存',
      openSignWindowFailed: '打开签署窗口失败: ',
      signSuccess: '文档签署完成！',
      validation: {
        taskNameRequired: '任务名称不能为空',
        templateRequired: '请选择合同模板',
        deadlineRequired: '请选择截止时间',
        participantsRequired: '请添加至少一名参与人',
        operationFailed: '操作失败，请重试'
      },
      participant: {
        status: {
          pending: '待签署',
          signed: '已签署',
          rejected: '已拒绝'
        }
      },
      participantStatus: {
        pending: '待签署',
        signed: '已签署',
        rejected: '已拒绝'
      },
      participantLabel: '参与者',
      autoLayout: '自动布局',
      clearAll: '清空所有',
      currentSelected: '当前选中',
      designTip: '请在PDF上点击设置该参与者的签名位置，或使用自动布局功能。',
      positionDetail: '签名位置详情',
      pageNumber: '页码',
      xCoordinate: 'X坐标',
      yCoordinate: 'Y坐标',
      width: '宽度',
      height: '高度',
      label: '标签',
      positionLabel: '签名位置标签',
      onlineSign: '在线签署文档',
      totalPages: '共 {total} 页',
      sealSelectedGuide: '已选择印章 "{name}"，点击PDF页面放置印章',
      noDocumentContent: '暂无文档内容',
      clickToPlaceSeal: '点击放置印章',
      sealSelection: '签名/印章选择',
      selected: '已选择',
      pleaseSelectSeal: '请选择印章',
      sealDeleted: '印章已删除',
      dragSealToPdf: '请将印章拖拽到PDF页面上的指定位置',
      createSeal: '创建印章',
      initSuccess: '初始化成功',
      sealLoadFailed: '印章加载失败',
      sealPermissionError: '印章权限不足',
      userNotLoggedIn: '用户未登录',
      getSealError: '获取印章失败',
      pleaseSelectSealFirst: '请先选择一个印章',
      pleaseAddSealFirst: '请先在文档上添加印章',
      signFailed: '签署失败',
      noAvailableSeals: '暂无可用印章',
      noSealsCreated: '您还没有创建任何印章',
      goToSealManagementTip: '请先前往 <strong>印章管理</strong> 页面创建印章',
      goCreateSeal: '去创建印章',
      waitingOperation: '等待操作',
      clickPdfToPlaceSeal: '请在左侧PDF页面上点击要放置印章的位置',
      ready: '已准备就绪',
      sealsAddedReady: '已添加 {count} 个印章，可以开始签署',
      startSigning: '开始签署',
      selectSealAndPlace: '请先选择一个印章，然后在PDF上放置',
      sealManagementGuide: '签章操作说明',
      dragToAdjustPosition: '拖拽已放置的印章可调整位置',
      clickToSelectSeal: '普通章模式：从右侧选择印章拖到PDF页面',
      adjustSealSize: '骑缝章模式：将印章拖到骑缝区域，自动覆盖所有页面',
      clickDeleteToRemove: '悬停印章显示删除按钮，点击可移除',
      signDocument: '签署文档',
      positionSetForParticipant: '已为 {name} 设置签名位置',
      noParticipantsToSet: '没有参与者需要设置签名位置',
      clearAllPositionsConfirm: '确定要清空所有签名位置吗？',
      allPositionsCleared: '已清空所有签名位置',
      positionSaved: '签名位置已保存',
      selectSealAndDrag: '请先选择一个印章，然后拖拽到PDF上放置',
      dragSealHere: '拖拽印章到此处',
      sealSelectedDragTip: '已选择印章 "{name}"，请拖拽到PDF页面上放置',
      sealPlacedSuccess: '印章 "{name}" 已成功放置',
      sealOutOfBounds: '印章不能放置在PDF页面边界外',
      invalidDropArea: '请将印章拖拽到PDF页面内',
      sealPositionAdjusted: '印章位置已自动调整到页面边界内',
      // 骑缝章相关文本
      normalMode: '普通章',
      perforationMode: '骑缝章',
      modeSwitch: '签章模式',
      perforationGuide: '骑缝章会在所有页面显示，拖拽到右侧骑缝区域',
          dragToPerforationZone: '该区域为骑缝签署区域请将印章拖放此处',
    perforationZoneHint: '该区域为骑缝签署区域请将印章拖放此处',
          perforationSealAlreadyExists: '骑缝区域已存在印章，请先删除现有印章再添加新的',
          sealOverlapDetected: '印章位置重叠，请调整位置后重试',
      perforationSealPlaced: '骑缝章已放置到 {count} 个页面',
      performanceWarning: '文档页数较多（{pages}页），可能影响性能，建议谨慎操作',
      perforationDeleteConfirm: '删除骑缝章将移除所有页面的印章，确认删除？',
      onlyVerticalAdjustment: '骑缝章只能上下调整位置',
      perforationSealPlacedSuccess: '骑缝章 "{name}" 已成功放置到{pages}页',
      perforationSealDeleted: '骑缝章已删除',
      perforationSealPositionAdjusted: '骑缝章位置已自动调整',
      perforationSealOutOfBounds: '请将骑缝章拖拽到骑缝区域内',
      // 新增签署相关提示
      noValidSealSelected: '没有找到有效的印章，请确保印章已正确放置',
      perforationSignProcessing: '正在处理骑缝章签署...',
      perforationSignSuccess: '骑缝章签署成功！',
      
      // 纯前端PDF编辑器相关
      pureFrontendPdfEditor: '纯前端PDF签署',
      pureFrontendMode: '纯前端模式',
      realTimeEditing: '实时编辑',
      autoSaved: '已自动保存',
      editingTools: '编辑工具',
      untitledTask: '未命名任务',
      instantSign: '即时签署',
      livePreview: '实时预览',
      stopPreview: '停止预览',
      fullPreview: '完整预览',
      compareVersions: '版本对比',
      download: '下载',
      clearAllSeals: '清除所有印章',
      sealCount: '已添加 {count} 个印章',
      availableSeals: '可用印章',
      dragging: '拖拽中',
      sealDragged: '印章已移动到新位置',
      emptyDocumentUrl: '文档地址为空',
      
      // 加载状态文本
      loading: {
        initializing: '正在初始化...',
        checkingPermissions: '正在检查权限...',
        loadingPdf: '正在加载PDF...',
        renderingPdf: '正在渲染PDF...',
        loadingSeals: '正在加载印章...',
        loadingDraft: '正在加载草稿...'
      },

      
      // 错误信息
      error: {
        taskNotInProgress: '任务未在进行中，无法签署',
        taskNotAvailable: '任务已撤销、拒签或过期，无法操作',
        notParticipant: '您不是该任务的参与者',
        permissionCheckFailed: '权限验证失败',
        noViewPermission: '无查看权限',
        noSignPermission: '无签署权限',
        pdfLoadFailed: 'PDF加载失败',
        initFailed: '初始化失败',
        sealLoadFailed: '印章加载失败',
        noPdfLoaded: '未加载PDF文档',
        signFailed: '签署失败',
        downloadFailed: '下载失败'
      },
      
      // 警告信息
      warning: {
        noAvailableSeals: '暂无可用印章',
        sealLoadFailed: '印章加载失败',
        sealOutOfBounds: '印章位置超出边界',
        cannotSign: '当前无法签署',
        pleaseAddSeal: '请先添加印章'
      },
      
      // 成功信息
      success: {
        sealAdded: '印章"{name}"添加成功',
        sealRemoved: '印章"{name}"已移除',
        allSealsCleared: '所有印章已清除',
        signCompleted: '签署完成',
        downloadCompleted: '下载完成'
      },
      
      // 确认对话框
      confirm: {
        title: '操作确认',
        instantSign: '确认进行即时签署吗？此操作不可撤销。',
        clearAllSeals: '确认清除所有印章吗？'
      },
      
      // 签署人时间线相关
      signingProgress: '签署进度',
      totalParticipants: '总参与人数',
      signed: '已签署',
      pending: '待处理',
      hasRejected: '有人拒签',
      allSigned: '全部签署',
      waitingToSign: '等待签署',
      formFillingInfo: '表单填写信息',
      formFilledTime: '填写时间',
      formDataVersion: '数据版本',
      signatureInfo: '签署信息',
      usedSeal: '使用印章',
      signedAt: '签署时间',
      fileHash: '文件哈希',
      generating: '生成中',
      rejectInfo: '拒签信息',
      rejectedAt: '拒签时间',
      twoStageMode: '两阶段模式',
      directSignMode: '直接签署模式',
      formFilled: '已填写表单',
      taskCompleted: '任务已完成',
      youHaveSigned: '您已完成签署',
      taskCancelled: '任务已取消',
      taskCompletedDesc: '所有参与人已完成签署',
      signDetails: '签署详情',
      contractInfo: '合同信息',
      contractName: '合同名称',
      createTime: '创建时间',
      completeTime: '完成时间',
      contractHash: '合同哈希',
      downloadContract: '下载合同',
      viewContract: '查看合同',
      backToList: '返回列表',
      noParticipants: '暂无参与人',
      
      // 信息提示
      info: {
        previewFeatureComingSoon: '预览功能即将上线',
        pureFeModifyAllowed: '纯前端模式允许重新编辑'
      },
      
      // 元数据
      metadata: {
        signedDocument: '已签署文档',
        systemName: '电子签章系统',
        digitalSignature: '数字签名'
      },
      
      // 表单编辑相关
      sealMode: '印章模式',
      formMode: '表单模式', 
      hybridMode: '混合模式',
      
      // 模式说明
      sealModeDesc: '仅显示印章工具，用于在PDF上添加电子印章',
      formModeDesc: '仅显示表单工具，用于填写PDF中的表单字段',
      hybridModeDesc: '同时显示印章和表单工具，支持完整的PDF编辑功能',
      
      singlePageView: '单页视图',
      multiPageView: '多页视图',
      singlePageViewDesc: '一次只显示一页PDF，适合专注编辑',
      multiPageViewDesc: '同时显示所有页面，便于整体预览',
      detectFormFields: '检测表单字段',
      clearAllFormFields: '清除所有字段',
      formFieldCount: '已添加 {count} 个字段',
      formFieldsDetected: '检测到 {count} 个表单字段',
      formFieldDetectionFailed: '表单字段检测失败',
      formFieldRemoved: '字段"{name}"已移除',
      allFormFieldsCleared: '所有表单字段已清除',
      modeChanged: '已切换到{mode}',
      detectingFormFields: '正在检测表单字段...',
      noPdfLoaded: '未加载PDF文档',
      
      // 页面导航相关
      previousPage: '上一页',
      nextPage: '下一页',
      jumpToThisPage: '跳转到此页',
      togglePageView: '切换视图模式',
      viewModeChanged: '已切换到{mode}',
      formFieldAdded: '字段"{name}"已添加',
      
      // 业务逻辑增强相关
      taskDetails: '任务详情',
      taskId: '任务编号',
      initiator: '发起人',
      currentUser: '当前用户',
      permissions: '权限',
      canView: '可查看',
      canSign: '可签署',
      canEdit: '可编辑',
      canDownload: '可下载',
      restrictedAccess: '受限访问',
      moreActions: '更多操作',
      saveAsDraft: '保存草稿',
      exportSettings: '导出设置',
      operationHistory: '操作历史',
      resetAll: '重置全部',
      today: '今天',
      yesterday: '昨天',
      daysAgo: '天前',
      
      // 错误信息增强
      alreadySigned: '您已经签署过此任务',
      initiatorCannotSign: '发起者不能签署自己的任务',
      taskExpired: '任务已过期',
      noEditPermission: '无编辑权限',
      draftSaveFailed: '草稿保存失败',
      
      // 成功信息增强
      draftSaved: '草稿已保存',
      settingsExported: '设置已导出',
      resetCompleted: '重置完成',
      
      // 加载状态增强
      savingDraft: '正在保存草稿...',

      
      // 信息提示增强
      historyFeatureComingSoon: '操作历史功能即将上线',
      
      // 文件处理和同步相关
      uploadingPdf: '正在上传PDF文件...',
      syncingStatus: '正在同步签署状态...',
      verifyingIntegrity: '正在验证文件完整性...',
      loadingDraft: '正在加载草稿...',
      
      // 错误信息 - 文件处理
      integrityVerificationFailed: '文件完整性验证失败',
      
      // 警告信息 - 草稿管理
      draftSavedLocally: '网络异常，草稿已保存到本地',
      
      // 成功信息 - 草稿管理
      draftLoaded: '草稿加载成功',
      
      // 信息提示 - 草稿管理
      localDraftLoaded: '已从本地存储加载草稿',
      
      // 流程状态和阶段
      formFillingStage: '表单填写阶段',
      formFillingDescription: '请填写必要的表单信息后提交',
      formFields: '表单字段',
      noFormFields: '暂无表单字段',
      requiredFields: '必填字段',
      optionalFields: '选填字段',
      required: '必填',
      pageIndicator: '第 {current} 页，共 {total} 页',
      submitForm: '提交表单',
      updateForm: '更新表单',
      submitSuccess: '提交成功',
      updateSuccess: '更新成功',
      notParticipant: '您不是该任务的参与人',
      loadFailed: '加载失败',
      unknownStage: '未知流程阶段',
      contactSupport: '请联系系统管理员或技术支持',
      
      // 表单填写完成提示
          formFilledSuccessTitle: '表单填写完成！',
          formFilledSuccessSubtitle: '您已成功提交表单数据，可以返回列表或查看已填写的内容',
          formFilledNotice: '后续操作提示',
          formFilledNoticeContent: '您可以随时返回查看和修改表单数据。所有参与人填写完成后，即可进行签署操作。',
          waitingOthersToFillFormHint: '他人填写完成后方可签署',
      viewFormData: '查看表单数据',
      canModifyFormData: '您可以查看并修改表单数据',
      goToSign: '前往签署',
      
      // 直接签署模式提示
      needSignTitle: '请使用签署功能',
      needSignSubtitle: '该任务需要您进行签署操作',
      needSignNotice: '签署提示',
      needSignNoticeContent: '请点击"前往签署"按钮，使用专门的签署页面完成签署操作。',
      
      // 只读模式
      viewOnlyMode: '当前为只读模式，表单数据不可修改'
    }
  }
}
